import React, { useState, useRef } from "react";
import { Button } from "primereact/button";
import { getSocket } from '../context/socket';
import { useAuth } from "../context/AuthContext";
import CustomToast from "./CustomToast";
import { Form, Col } from 'react-bootstrap';
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from 'primereact/tooltip';

const CardSectionMeeting = ({ onCancel, togglePopup, cardId, boardId }) => {
    const toastRef = useRef(null);

    const { userId } = useAuth();
    const socket = getSocket();


    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };

    const [formData, setFormData] = useState({
        meeting_title: "",
        meeting_type: "",
        date: null,
        meeting_members: "",
        agenda: "",
        action_items: "",
        discussions: "",
        decisions: "",
        client_updates: ""
    });
    const meetingTypes = [
        { label: 'Call', value: 'Call' },
        { label: 'Video Call', value: 'Video_call' },
        { label: 'In Person', value: 'In_person' },
        { label: 'Hybrid', value: 'Hybrid' },
        { label: 'Internal', value: 'Internal' },
        { label: 'Client Meeting', value: 'Client_meeting' },
        { label: 'Presentation', value: 'Presentation' },
        { label: 'Review', value: 'Review' },
        { label: 'Training', value: 'Training' },
        { label: 'Brainstorming', value: 'Brainstorming' }
    ];


    const handleChange = (e) => {
        const { name, value } = e.target || {};
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleInsert = () => {
        if (!formData.meeting_title || !formData.date) {
            showMessage("warn", "Meeting title and date are required.");
            return;
        }
    
        const formattedDate = formData.date.toISOString().split("T")[0]; // Extracts "YYYY-MM-DD"
    
        socket.emit("add_section_meeting", {
            card_id: cardId,
            user_id: userId,
            meeting: {
                ...formData,
                date: formattedDate
            }
        });
    
        togglePopup("meeting");
    };
    

    return (
        <div className="popup-box popup-meeting">
            <div className="popup-header">
            Meeting Details
                <Button icon="pi pi-times" className="p-button-text close-btn" onClick={() => togglePopup("meeting")} />
            </div>
            <div className="popup-body">
                <div className="list-EmpLIst">
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <label>
                            Meeting Title
                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                data-pr-tooltip="Note: This title will be visible in the minutes of meeting."
                            />
                            <Tooltip target=".custom-target-icon" />
                        </label>
                        <InputText name="meeting_title" value={formData.meeting_title} onChange={handleChange} className="w-100" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <label>Meeting Type</label>
                        <Dropdown
                            name="meeting_type"
                            value={formData.meeting_type}
                            options={meetingTypes}
                            onChange={handleChange}
                            placeholder="Select Meeting Type"
                            className="w-100"
                        />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <label>Date</label>
                        <Calendar name="date" value={formData.date} onChange={handleChange} dateFormat="dd-mm-yy" className="w-100"  />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <label>Meeting Members</label>
                        <InputTextarea rows={3} name="meeting_members" value={formData.meeting_members} onChange={handleChange} className="w-100 h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <label>Agenda</label>
                        <InputTextarea rows={3} name="agenda" value={formData.agenda} onChange={handleChange} className="w-100 h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <label>Action Items</label>
                        <InputTextarea rows={3} name="action_items" value={formData.action_items} onChange={handleChange} className="w-100 h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <label>Discussions</label>
                        <InputTextarea rows={3} name="discussions" value={formData.discussions} onChange={handleChange} className="w-100 h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <label>Decisions</label>
                        <InputTextarea rows={3} name="decisions" value={formData.decisions} onChange={handleChange} className="w-100 h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <label>Client Updates</label>
                        <InputTextarea rows={3} name="client_updates" value={formData.client_updates} onChange={handleChange} className="w-100 h-auto" />
                    </Col>
                </div>

                <Button label="Insert" severity="primary" className="border-0 py-1 px-3 mt-3 me-2" onClick={handleInsert} />
                <Button label="Cancel" severity="secondary" className="border-0 py-1 px-3 mt-3 opacity-75" onClick={() => togglePopup("meeting")} />
            </div>

            <CustomToast ref={toastRef} />
        </div>
    );
};
export default CardSectionMeeting
